import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles } from '../styles/Styles';
import { MultiTextComponent } from './quizzing/MultiTextComponent';
import { ButtonComponent } from './quizzing/ButtonComponent';
import { TextComponent } from './quizzing/TextComponent';
import { dataItem } from '../data/data';
import { AppHelper } from '../helpers/AppHelper';
import { ValidationHelper } from '../common/helpers/ValidationHelper';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { UiHelper } from '../common/helpers/UiHelper';
import { AppTheme } from '../styles/AppTheme';
import { MsgDialog } from '../components/MsgDialog';

export class CatHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchState: ApiHelper.State.LOADING,
    }
  }

  componentDidMount() {
  }


  showCatInfoDialog = () => {
    const catType = this.props.catType
    let descr = '', catTitle = ''
    if (catType === 'essential') {
      descr = dataItem.surveyCatInfo.essential.descr
      catTitle = dataItem.surveyCatInfo.essential.title
    } else if (catType === 'recommended') {
      descr = dataItem.surveyCatInfo.recommended.descr
      catTitle = dataItem.surveyCatInfo.recommended.title
    } else if (catType === 'optional') {
      descr = dataItem.surveyCatInfo.optional.descr
      catTitle = dataItem.surveyCatInfo.optional.title
    }
    this.catTitle = catTitle
    this.catInfoContent = descr
    this.setState({
      catInfoDialog: true
    })
  }

  getTitle = () => {
    const catType = this.props.catType
    if (catType === 'essential') {
      return dataItem.surveyCatInfo.essential.title
    } else if (catType === 'recommended') {
      return dataItem.surveyCatInfo.recommended.title
    } else if (catType === 'optional') {
      return dataItem.surveyCatInfo.optional.title
    }
  }

  closeCatInfoDialog = () => {
    this.setState({
      catInfoDialog: false
    })
  }

  render() {
    return (
      <div className={css(Styles.catTitleContainer)}>
        <p className={css(Styles.catTitle)}>{this.getTitle()}</p>
        <div className={css(CommonStyles.questionDetailContainer, Styles.customSizeCatInfo)} onClick={() => this.showCatInfoDialog()}>
          <p className={css(CommonStyles.questionDetailContent, Styles.customFontSizeCatInfo)}>i</p>
        </div>
        <MsgDialog
          showDialog={this.state.catInfoDialog}
          closeDialog={this.closeCatInfoDialog}
          title={this.catTitle}
          dialogContainerStyle={Styles.catInfoDialogContainer}
          rightBtnTitle={'OK'}
          descr={this.catInfoContent}
        />
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  catTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  catTitle: {
    fontSize: 23,
    color: AppTheme.textColorVariant,
    margin: AppTheme.pMargin,
    textAlign: 'center',
  },
  customSizeCatInfo: {
    height: 18,
    width: 18,
  },
  customFontSizeCatInfo: {
    fontSize: 18,
  },
  catInfoDialogContainer: {
    maxWidth: 750,
    borderRadius: 31,
    '@media (max-width: 767px)': {
      maxWidth: 'unset',
    },
    padding: 10,
  },
})


// WEBPACK FOOTER //
// ./src/components/CatHeader.js